<template>

  <div>
    <head-top></head-top>
    <el-row style="margin-top: 20px;" v-loading="loading">
      <el-col :span="20">
        <el-form :model="formData"  ref="formData" label-width="120px" class="demo-formData">
          <el-form-item label="课程名称" prop="name">
            <el-input v-model="formData.name" style="width: 200px"></el-input>
          </el-form-item>
          <el-form-item label="课程类型">
            <el-select v-model="formData.type" placeholder="请选择" style="width: 200px">
              <el-option
                v-for="item in options"
                :key="item.id"
                :label="item.label"
                :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="课程封面" prop="img">
            <el-upload
              class="upload-demo"
              action="http://mapi.eduscb.com/smallpargramback/updaloFile/upload"
              :on-remove="handleRemove"
              :on-success='handlesuccess'
              :before-upload="beforeUploadimg"
              :headers="myHeaders"
              multiple
              :limit="1"
              :data = "{type:1}"
              :on-exceed="handleExceed">
              <img v-if="dialogImageUrl" :src="dialogImageUrl" class="avatar">
              <el-button size="small" type="primary" v-if="dialogVisible">点击上传</el-button>
            </el-upload>
          </el-form-item>
          <el-form-item label="视频封面" prop="img">
            <el-upload
              class="upload-demo"
              action="http://mapi.eduscb.com/smallpargramback/updaloFile/upload"
              :on-remove="handleRemoveo"
              :on-success='videoImgsuccess'
              :before-upload="beforeUploadimg"
              :headers="myHeaders"
              multiple
              :limit="1"
              :data = "{type:1}"
              :on-exceed="handleExceed">
              <img v-if="dialogVioImageUrl" :src="dialogVioImageUrl" controls="controls" class="avatar">
              <el-button size="small" type="primary" v-if="dialogVisible3">点击上传</el-button>
            </el-upload>
          </el-form-item>
          <el-form-item label="视频附件" prop="vio">
            <el-upload
              id="videoplayer"
              class="upload-demo"
              action="http://mapi.eduscb.com/smallpargramback/updaloFile/upload"
              :on-remove="handleRemovevio"
              :on-success="handleVideoSuccess"
              :before-upload="beforeUploadVideo"
              :headers="myHeaders"
              multiple
              :limit="1"
              :data = "{type:2}"
              :on-exceed="handleExceeds">
              <video v-if="dialogVideoUrl" :src="dialogVideoUrl" controls="controls" class="avatar"></video>
              <el-button size="small" type="primary" v-if="dialogVisible2">点击上传</el-button>
              <video :src="dialogVideotime"  id="viderplayer" style="display: none"></video>
            </el-upload>
          </el-form-item>
          <!--图文教程-->
          <el-form-item label="简介">
            <el-button size="small" type="primary"  @click="dialogFormVisible4 = true">添加教程</el-button>

          </el-form-item>
          <el-table
            :data="tablesData"
            style="width: 100%;margin-left:60px;">
            <el-table-column
              type="index"
              label="序号"
              width="180">
            </el-table-column>
            <el-table-column
              prop="description"
              label="描述"
              width="180">
            </el-table-column>
            <el-table-column
              prop="imageUrl"
              label="图片地址">
            </el-table-column>
            <el-table-column
              label="操作">
              <template slot-scope="scope">
                <el-button size="mini" type="text" @click="Viewmaterials(scope.$index, scope.row)">查看</el-button>
                <el-button size="mini" type="text" @click="Editmaterials(scope.$index, scope.row)">编辑</el-button>
                <el-button size="mini" type="text" @click="handleDeletes(scope.$index, scope.row)">删除</el-button>
              </template>
            </el-table-column>
          </el-table>
          <!-- 新增作品 -->
          <el-form-item label="作品赏析">
            <el-button size="small" type="primary"  @click="dialogFormVisible = true">添加作品</el-button>

          </el-form-item>
          <el-table
            :data="tableData"
            style="width: 100%;margin-left:60px;">
            <el-table-column
              type="index"
              label="序号"
              width="180">
            </el-table-column>
            <el-table-column
              prop="studentName"
              label="学生姓名"
              width="180">
            </el-table-column>
            <el-table-column
              prop="worksUrl"
              label="作品地址">
            </el-table-column>
            <el-table-column
              label="操作">
              <template slot-scope="scope">
                <el-button size="mini" type="text" @click="Viewmaterial(scope.$index, scope.row)">查看</el-button>
                <el-button size="mini" type="text" @click="Editmaterial(scope.$index, scope.row)">编辑</el-button>
                <el-button size="mini" type="text" @click="handleDelete(scope.$index, scope.row)">删除</el-button>
              </template>
            </el-table-column>
          </el-table>

          <!--添加学生作品-->
          <el-dialog title="添加作品" :visible.sync="dialogFormVisible">
            <el-form>
              <el-form-item label="学生姓名" :label-width="formLabelWidth">
                <el-input v-model="form.name" autocomplete="off" maxlength = "6" ></el-input>
              </el-form-item>
              <el-form-item label="图片附件" :label-width="formLabelWidth" class="mar">
                <el-upload
                  action="http://mapi.eduscb.com/smallpargramback/updaloFile/upload"
                  :on-remove="handleRemove"
                  :on-success='handlessuccess'
                  :before-upload="beforeUploadimg"
                  :headers="myHeaders"
                  multiple
                  v-model="form.img"
                  :file-list="fileList"
                  :limit="1"
                  :data = "{type:1}">
                  <el-button size="small" type="primary">点击上传</el-button>
                </el-upload>
              </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
              <el-button @click="cancel1">取 消</el-button>
              <el-button type="primary" @click="Addworks()">确 定</el-button>
            </div>
          </el-dialog>
          <!--查看-->
          <el-dialog title="查看作品" :visible.sync="dialogFormVisible2">
            <el-form>
              <el-form-item label="描述" width="300px">
                <span>{{addForm.name}}</span>
              </el-form-item>
              <el-form-item label="图片附件" class="mar" >
                <img v-bind:src="addForm.img">
              </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
              <el-button @click="dialogFormVisible2 = false">取 消</el-button>
              <el-button type="primary" @click="dialogFormVisible2 = false">确 定</el-button>
            </div>
          </el-dialog>
          <!--编辑-->
          <el-dialog title="编辑作品" :visible.sync="dialogFormVisible3">
            <el-form>
              <el-form-item label="学生姓名" :label-width="formLabelWidth">
                <el-input v-model="form.name" autocomplete="off" maxlength="6" ></el-input>
              </el-form-item>
              <el-form-item label="图片附件" :label-width="formLabelWidth" class="mar">
                <el-upload
                  action="http://mapi.eduscb.com/smallpargramback/updaloFile/upload"
                  :on-remove="handleRemove"
                  :on-success='handlessuccess'
                  :before-upload="beforeUploadimg"
                  :headers="myHeaders"
                  multiple
                  v-model="form.img"
                  :limit="1"
                  :data = "{type:1}">
                  <el-button size="small" type="primary">点击上传</el-button>
                </el-upload>
              </el-form-item>
              <el-form-item label="图片附件:" prop="img" :label-width="formLabelWidth">
                <img v-bind:src="form.img" style="width: 80%">
              </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
              <el-button @click="dialogFormVisible3 = false">取 消</el-button>
              <el-button type="primary" @click="addSubmit()">确 定</el-button>
            </div>
          </el-dialog>
          <!--添加图文教程-->
          <el-dialog title="添加教程" :visible.sync="dialogFormVisible4">
            <el-form>
              <el-form-item label="描述" :label-width="formLabelWidth">
                <el-input
                  type="textarea"
                  :rows="5"
                  v-model="Godaddy.name">
                </el-input>
              </el-form-item>
              <el-form-item label="图片附件" :label-width="formLabelWidth" class="mar">
                <el-upload
                  action="http://mapi.eduscb.com/smallpargramback/updaloFile/upload"
                  :on-remove="handleRemove"
                  :on-success='Godaddysuccess'
                  :before-upload="beforeUploadimg"
                  :headers="myHeaders"
                  multiple
                  v-model="Godaddy.img"
                  :file-list="fileList"
                  :limit="1"
                  :data = "{type:1}">
                  <el-button size="small" type="primary">点击上传</el-button>
                </el-upload>
              </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
              <el-button @click="cancel2">取 消</el-button>
              <el-button type="primary" @click="Godaddys()">确 定</el-button>
            </div>
          </el-dialog>
          <!--查看图文教程-->
          <el-dialog title="查看教程" :visible.sync="dialogFormVisible5">
            <el-form >
              <el-form-item label="描述" width="300px">
                <span>{{Godaddy.name}}</span>
              </el-form-item>
              <el-form-item label="图片附件" class="mar" >
                <img v-bind:src="Godaddy.img" />
              </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer" >
              <el-button @click="dialogFormVisible5 = false">取 消</el-button>
              <el-button type="primary" @click="dialogFormVisible5 = false">确 定</el-button>
            </div>
          </el-dialog>
          <!--修改图文教程-->
          <el-dialog title="编辑教程" :visible.sync="dialogFormVisible6">
            <el-form>
              <el-form-item label="课程描述" :label-width="formLabelWidth">
                <el-input
                  type="textarea"
                  :rows="5"
                  v-model="Godaddy.name">
                </el-input>
              </el-form-item>
              <el-form-item label="图片附件" :label-width="formLabelWidth" class="mar">
                <el-upload
                  action="http://mapi.eduscb.com/smallpargramback/updaloFile/upload"
                  :on-remove="handleRemove"
                  :on-success='Godaddysuccess'
                  :before-upload="beforeUploadimg"
                  :headers="myHeaders"
                  multiple
                  v-model="Godaddy.img"
                  :file-list="fileList"
                  :limit="1"
                  :data = "{type:1}">
                  <div slot="tip" class="el-upload__tip">请上传688×326的jpg/png图片，且不超过500kb</div>
                  <el-button size="small" type="primary">点击上传</el-button>
                </el-upload>
              </el-form-item>
              <el-form-item label="图片附件:" prop="img" :label-width="formLabelWidth">
                <img v-bind:src="Godaddy.img" style="width: 80%">
              </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
              <el-button @click="dialogFormVisible4 = false">取 消</el-button>
              <el-button type="primary" @click="Godaddysubmit()">确 定</el-button>
            </div>
          </el-dialog>
          <div class="but_bot">
            <el-button type="primary" @click="submit()">提交</el-button>
            <el-button type="primary" @click="cancel()">取消</el-button>
          </div>
        </el-form>
      </el-col>
    </el-row>
  </div>
</template>

<script>
  import headTop from '@/components/headTop'
  import { getExinformation,getModcourses  } from "../api/api"
  import axios from 'axios'
  export default {
    inject: ['reload'],
    data(){
      return {
        options: [{
          id: '41',
          label: '试看普通'
        }, {
          id: '42',
          label: '试看热门'
        }, {
          id: '43',
          label: '试看精品'
        }, {
          id: '44',
          label: '平台视频'
        }],
        tableData: [],
        tableDataDel: [],
        tablesData: [],
        tablesDataDel:[],
        fileList:[],
        currentPage:1,
        limit:20,
        formData: {
          name: '', //课程名称
          type:'',
          vio:"",//视频
          img:"",//封面
          tutorial:"",//教程
          newworks:"",//新增作品
        },
        dialogFormVisible: false,
        dialogFormVisible2: false,
        dialogFormVisible3: false,
        dialogFormVisible4: false,
        dialogFormVisible5: false,
        dialogFormVisible6: false,
        dialogVisible:false,
        dialogVisible2:false,
        dialogVisible3:false,
        form: {
          name: '',
          img:''
        },
        Godaddy:{
          name:'',
          img:''
        },
        formLabelWidth: '80px',
        toatDuartion:'',
        videoUrl:'',
        imageUrl:'',
        worksUrl:'',
        tableDatas:[],
        courseManagent:{},
        addForm:{},
        cover:'', //课程封面
        index:0,
        dialogImageUrl: '',
        dialogVideoUrl:'',
        dialogVioImageUrl:'',
        videoImage:'',
        dialogVideotime:'',
        timeLength:'',
        myHeaders: {token: sessionStorage.token},
        num:'',
        loading:false,
      }
    },
    components: {
      headTop
    },
    methods:{
      //时间戳转换
      formatDate:function (value){
        var dateee = new Date(value.updateTime).toJSON();
        return new Date(+new Date(dateee)+8*3600*1000).toISOString().replace(/T/g,' ').replace(/\.[\d]{3}Z/,'')
      },
      //获取课程信息
      getinformation(){
        let params = {
          courseId:this.$route.query.id,
          category:this.$route.query.category
        }
        getExinformation(params).then(res=>{
          this.formData.type = JSON.stringify(res.category)
          this.formData.name = res.courseName
          this.tableData = res.list
          this.tablesData = res.textList
          this.dialogImageUrl = res.imageUrl
          this.cover = res.imageUrl
          this.dialogVideoUrl = res.videoUrl
          this.videoUrl = res.videoUrl
          this.dialogVioImageUrl = res.videoImage
          this.videoImage = res.videoImage
          this.timeLength = res.timeLength
          this.index = res.textList[res.textList.length-1].sort+1
          if (this.dialogImageUrl == ''){
            this.dialogVisible = true
          } else if (this.dialogVioImageUrl == '') {
            this.dialogVisible3 = true
          }else if (this.dialogVideoUrl){
            this.dialogVisible2 = true
          }
        }).catch(error=>{

        })
      },
      //上传课程封面
      handlesuccess(response, file, fileList){
        if(file.response.state == true){
          this.cover = file.response.url
          this.dialogImageUrl = file.response.url
        }else{
          this.$message.error('图片上传失败');
        }
      },
      videoImgsuccess(response, file, fileList){
        //response即为后台返回的全部内容
        if(file.response.state == true){
          this.videoImage = file.response.url
          this.dialogVioImageUrl = file.response.url
        }else{
          this.$message.error('图片上传失败');
        }
      },
      Godaddysuccess(response, file, fileList){
        if(file.response.state == true){
          this.Godaddy.img = file.response.url
        }else{
          this.$message.error('图片上传失败');
        }
      },
      handlessuccess(response, file, fileList){
        //response即为后台返回的全部内容
        if(file.response.state == true){
          this.form.img = file.response.url
        }else{
          this.$message.error('图片上传失败');
        }
      },
      handleExceed(files, fileList) {
        this.$message.warning(`最多上传一张封面`);
      },
      handleExceeds(files, fileList) {
        this.$message.warning(`最多上传一个视频`);
      },
      //课程封面删除
      handleRemove(file, fileList) {
        this.dialogImageUrl = ''
        this.dialogVisible = true
      },
      //视频封面删除
      handleRemoveo(file, fileList) {
        this.dialogVioImageUrl = ''
        this.dialogVisible3 = true
      },
      //视频删除
      handleRemovevio(file, fileList) {
        this.dialogVideoUrl = ''
        this.dialogVisible2= true
      },
      beforeUploadVideo(file) {
        if (['video/mp4', 'video/ogg', 'video/flv','video/avi','video/wmv','video/rmvb'].indexOf(file.type) == -1) {
          this.$message.error('请上传正确的视频格式');
          return false
        }
      },
      beforeUploadimg(file) {
        if (['image/jpg', 'image/png', 'image/jpeg', 'image/gif'].indexOf(file.type) == -1) {
          this.$message.error('请上传正确的图片格式');
          return false
        }
      },
      handleVideoSuccess(response, file, fileList){
        if(file.response.state == true){
          this.videoUrl = file.response.url
          this.dialogVideoUrl = file.response.playUrl
          this.dialogVideotime = file.response.playUrl
        }else{
          this.$message.error('视频上传失败');
        }
      },
      //图文教程添加
      Godaddys(){
        if(this.Godaddy.name == '' || this.Godaddy.img == ''){
          this.$message({
            type: 'error',
            message: '请上传完整信息'
          });
        } else {
          const tablesData = {}
          tablesData.sort = (this.index)++
          tablesData.description = this.Godaddy.name.replace(/ /g, "/t");
          tablesData.imageUrl = this.Godaddy.img;
          this.tablesData.push(tablesData);
          for (var i = 0; i < this.tablesData.length; i++) {
            if (this.tablesDataDel.indexOf(this.tablesData[i]) == -1) {
              this.tablesDataDel.push(this.tablesData[i]);
            }
          }
          this.Godaddy = {}
          this.fileList = [],
            this.dialogFormVisible4 = false
        }
      },
      //学生作品添加
      Addworks(date){
        if(this.form.name == '' || this.form.img == ''){
          this.$message({
            type: 'error',
            message: '请上传完整信息'
          });
        } else {
          const tableData = {};
          tableData.studentName = this.form.name.replace(/[^A-Za-z0-9\u4e00-\u9fa5]/g, '');
          tableData.operateId = 1001;
          tableData.worksUrl = this.form.img;
          this.tableData.push(tableData);
          for (var i = 0; i < this.tableData.length; i++) {
            if (this.tableDataDel.indexOf(this.tableData[i]) == -1) {
              this.tableDataDel.push(this.tableData[i]);
            }
          }
          this.form = {
            name: '',
            img:''
          },
          this.fileList = [],
          this.dialogFormVisible = false
        }
      },
      cancel1(){
        this.form = {
          name: '',
          img:''
        },
        this.fileList = []
        this.dialogFormVisible = false
      },
      cancel2(){
        this.Godaddy = {
          name:'',
          img:''
        }
        this.fileList = [],
        this.dialogFormVisible4 = false
      },
      //提交
      submit(){
        if (isNaN(document.getElementById('viderplayer').duration)) {
          this.timeLength = this.timeLength
        } else {
          this.timeLength = parseInt(document.getElementById('viderplayer').duration).toFixed(0)
        }
        this.loading = true
        let params = {
          courseId:this.$route.query.id,
          courseName:this.formData.name,
          timeLength:this.timeLength,
          videoUrl:this.videoUrl,
          imageUrl:this.cover,
          category:this.formData.type,
          text:JSON.stringify(this.tablesDataDel),
          operationId:JSON.parse(sessionStorage.getItem('user')).id,
          videoImage:this.videoImage,
          typeId:this.formData.classify,
          works:JSON.stringify(this.tableDataDel)
        }
        getModcourses(params).then((res)=>{
          if (res.state == true) {
            this.$message({
              type: 'success',
              message: res.msg
            });
            this.loading = false
            this.$router.back(-1)
          }else{
            this.$message({
              type: 'error',
              message: '请上传完整信息'
            });
            this.loading = false
          }
        }).catch(error=>{
          this.loading = false
          console.log(error)
        })
      },
      //取消
      cancel(){
        this.reload()
        this.$router.push('trialcourse')
      },
      handleDelete(index,row){
        //  删除学生作品
        this.$confirm('确认删除该记录吗？', '提示', {
          // type: 'warning'
        }).then(() => {
          row.state = 0
          for(var i = 0; i < this.tableData.length; i++){
            if(this.tableDataDel.indexOf(this.tableData[i]) == -1){
              this.tableDataDel.push(this.tableData[i]);
            }
          }
          this.tableData.splice(index, 1);
        }).catch(() => {
        })
      },
      Viewmaterials(index,row){
        //  查看图文教程
        this.dialogFormVisible5 = true
        this.Godaddy.name = row.description,
        this.Godaddy.img = row.imageUrl
      },
      //  删除图文教程
      handleDeletes(index,row){
        this.$confirm('确认删除该记录吗？', '提示', {
          // type: 'warning'
        }).then(() => {
          row.state = 0
          for(var i = 0; i < this.tablesData.length; i++){
            if(this.tablesDataDel.indexOf(this.tablesData[i]) == -1){
              this.tablesDataDel.push(this.tablesData[i]);
            }
          }
          this.tablesData.splice(index, 1);
        }).catch(() => {
        })
      },
      Editmaterial(index,row){
        //  编辑学生作品
        this.dialogFormVisible3 = true
        this.form.name = row.studentName
        this.form.img = row.worksUrl
        this.num = index
      },
      addSubmit(index,row){
        this.tableData[this.num].sort = this.Godaddy.sort
        this.tableData[this.num].studentName = this.form.name;
        this.tableData[this.num].worksUrl = this.form.img;
        for(var i = 0; i < this.tableData.length; i++){
          if(this.tableDataDel.indexOf(this.tableData[i]) == -1){
            this.tableDataDel.push(this.tableData[i]);
          }
        }
        this.form = {
          name: '',
          img:''
        },
          this.fileList = [],
          this.dialogFormVisible3 = false
      },
      Editmaterials(index,row){
        //  编辑图文教程
        this.dialogFormVisible6 = true
        this.Godaddy.name = row.description
        this.Godaddy.img = row.imageUrl
        this.Godaddy.sort = row.sort
        this.num = index
      },
      Godaddysubmit(index,row){
        this.tablesData[this.num].sort = this.Godaddy.sort
        this.tablesData[this.num].description = this.Godaddy.name.replace(/ /g, "/t");
        this.tablesData[this.num].imageUrl = this.Godaddy.img;
        for(var i = 0; i < this.tablesData.length; i++){
          if(this.tablesDataDel.indexOf(this.tablesData[i]) == -1){
            this.tablesDataDel.push(this.tablesData[i]);
          }
        }
        this.Godaddy = {
          name:'',
          img:''
        }
        this.fileList = [],
          this.dialogFormVisible6 = false
      },
      Viewmaterial(index,row){
        //  查看学生作品
        this.dialogFormVisible2 = true
        this.addForm.name = row.studentName,
          this.addForm.img = row.worksUrl
      },
    },
    computed: {
    },
    activated () {
      this.getinformation()
    },
  }
</script>
<style>
  .edit_container{
    padding: 40px;
    margin-bottom: 40px;
  }
  .editer{
    height: 300px;
  }
  .mar{
    margin-top:20px;
  }
  .el-input__inner{
    width: 200px;
  }
</style>




// WEBPACK FOOTER //
// src/page/modTrialCourse.vue